import { FC } from "react"
import classes from "./styles.module.scss"
import { SectionContainer } from "@/shared/ui/SectionContainer"
import { Card } from "@/shared/ui/Card"
import { Button, Flex, Stack, Text } from "@mantine/core"
import { Anchor } from "@/shared/ui/Anchor"
import ChevronRight from "@/shared/assets/icons/chevron-small-right.svg?react"
import cmLogo from "@/shared/assets/cm-logo.svg"
import { ContactModal } from "@/shared/ui"
import { Link } from "react-router-dom"
import { useAppSelector } from "@/shared/lib/store"
import {
	selectCompanyAddress,
	selectCompanyName,
	selectCompanyPhone,
	selectWorkTime,
} from "@/entities/options"
import { phoneNormalize } from "@/shared/lib/helpers"
import { useMediaQuery } from "@mantine/hooks"
import { selectAddFilters, selectPrivacyPolicy } from "@/entities/options/model/selectors"
import { Map } from "@/features/ymap"

interface FooterProps {}

export const Footer: FC<FooterProps> = ({}) => {
	const privacyPolicy = useAppSelector(selectPrivacyPolicy)
	const isSmallScreen = useMediaQuery("(max-width: 768px)")
	const companyName = useAppSelector(selectCompanyName)
	const companyAddress = useAppSelector(selectCompanyAddress)
	const companyPhone = useAppSelector(selectCompanyPhone)
	const companyWorkTime = useAppSelector(selectWorkTime)

	const addFilter = useAppSelector(selectAddFilters)

	return (
		<div className={classes.footer}>
			<SectionContainer>
				<Stack gap={32}>
					<Flex wrap="wrap" gap={32}>
						<Card
							title={
								<>
									Квартиры в <br />
									наличии
								</>
							}
							info={
								<Text fz={24} fw={600} lh={1.2}>
									{companyName}
								</Text>
							}
							description={companyAddress}
							variant="light"
							size="lg"
							flex={2}
							action={
								<ContactModal subject="Оставить заявку: Модальное окно - Подвал - Карточка квартиры в наличии">
									<Button
										size="md"
										h={50}
										px={36}
										py={12}
										miw={206}
										fullWidth={isSmallScreen}
										flex={1}
									>
										Оставить заявку
									</Button>
								</ContactModal>
							}
						/>
						<Card
							title="Связаться"
							info={
								<Anchor href={`tel:${phoneNormalize(companyPhone)}`}>
									<Text fz={24} fw={600}>
										{companyPhone}
									</Text>
								</Anchor>
							}
							description={
								<ContactModal
									title="Заказать обратный звонок"
									subtitle="Оставьте свои контакты, и наш менеджер свяжется с вами в ближайшее время"
									subject="Оставить заявку: Модальное окно - Подвал - Карточка квартиры в наличии"
								>
									<Button
										size="md"
										h={"auto"}
										p={0}
										fz={16}
										fw={500}
										c="#636363"
										variant="transparent"
										rightSection={<ChevronRight width={20} height={20} />}
										className={classes.button}
									>
										Заказать обратный звонок
									</Button>
								</ContactModal>
							}
							variant="gray"
							size="md"
							flex={1}
						/>
						<Card
							title="Режим работы"
							info={
								<Text fz={24} fw={600}>
									{companyWorkTime}
								</Text>
							}
							description="Ежедневно"
							variant="dark"
							size="md"
							flex={1}
						/>
					</Flex>
					{addFilter && (
						<div className={classes.map}>
							<Map />
						</div>
					)}
					<Flex wrap="wrap" justify="space-between" gap={16}>
						<Stack gap={2}>
							<Text fz={16} fw={500} c="#636363">
								© 2025. Все права защищены
							</Text>
							{privacyPolicy && (
								<Link to="/privacy" target="_blank">
									<Text fz={16} fw={500} c="#636363">
										Политика конфиденцильности
									</Text>
								</Link>
							)}
						</Stack>
						<Anchor
							href="https://convertme.ru/?utm_medium=referral&utm_source=website&utm_campaign=smart-catalog"
							target="_blank"
							rel="noreferrer"
							className={classes.cmLogo}
						>
							<img src={cmLogo} alt="логотип компании ConvertMe" />
						</Anchor>
					</Flex>
				</Stack>
			</SectionContainer>
		</div>
	)
}
